<template>
  <div class="login-container">
    <h2>Login Admin</h2>
    <form @submit.prevent="doLogin">
      <div>
        <label for="email">Email:</label>
        <input v-model="email" type="email" required />
      </div>
      <div>
        <label for="password">Contraseña:</label>
        <input v-model="password" type="password" required />
      </div>
      <button type="submit">Ingresar</button>
    </form>
    <p v-if="error" style="color: red">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import api from "../../api";


const email = ref("");
const password = ref("");
const error = ref(null);
const router = useRouter();

async function doLogin() {
  error.value = null;
  try {
    const resp = await api.post("/login", {
      email: email.value,
      password: password.value,
    });

    const token = resp.data.token;

    localStorage.setItem("token", token);

    api.defaults.headers.common["Authorization"] = "Bearer " + token;

    router.push("/listarColegiados");
  } catch (e) {
    error.value = "Credenciales incorrectas";
  } 
}
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #ccc;
}
.login-container div {
  margin-bottom: 12px;
}
</style>
